import { HubFeature } from '@ats/api/cm';
import { LocDef } from '@cm/core/localization';

export const pathStart = 'Settings|Score Report Delay|';
export const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamScoreReportsBatch,
	portal: 'SP',
};
